import {eINVALID} from "../variableDataBase/invalidvalue";
import {ClientList, ClimateComputer} from "./listclientsdata";
import {Climate} from "../clients/climate.model";
import {environment} from "../../environments/environment";



export interface ClimateItem {
  target: string;
  rights: string;
}

export class ClientListWithAccess {
  static accessToken: string = "";
  static climateList: ClimateItem[] = Array();

  static GetAccessListByToken() : string
  {
    return this.accessToken;
  }

  static SetAccessListByToken(accessToken: string): void
  {
    console.log('Access climateList Token is set', accessToken);
    this.accessToken = accessToken;
  }

  static SetAccessList(climateList: ClimateItem[]): void
  {
    console.log('Access climateList is set', climateList);
    this.climateList = climateList;
  }

  static Match(target: string,  clientName: string)
  {
      let cnt = 0;
      for(let ch of target)
      {
          if(ch == '*')
            return true;
          if(ch != clientName[cnt++])
            return false;
      }
      return true;
  }

  static CheckAccess(clientName:string) :boolean
  {
    if(clientName == 'AA0001')
      return true;
    if(clientName == 'SC1399')
      return true;
    if(clientName == 'SC0184')
      return true;

    if(environment.production == false)
      return true;

    if(clientName == 'localhost')
      return true;
    for(let client of ClientListWithAccess.climateList)
    {
      if(this.Match(client.target, clientName))
        return true;
    }
    return false;
  }

  static Filter(listClimate :ClimateComputer[]) : ClimateComputer[]
  {
      var listWithAccess: ClimateComputer[] = Array();

      var cnt = 0;
      for(let climate of listClimate)
      {
        if(this.CheckAccess(climate.name))
            listWithAccess.push(climate);
      }
      return listWithAccess;
  }



  static FilterNew(climatList :Climate[]) : Climate[]
  {
    var listWithAccess: Climate[] = [];

    var cnt = 0;
    for(let climate of climatList)
    {
      if(this.CheckAccess(climate.name))
        listWithAccess.push(climate);
    }
    return listWithAccess;
  }




}
